export const leftMenu = {
  "Deseja voltar da pausa:": "Deseja voltar da pausa:",
  "Tempo total em pausa:": "Tempo total em pausa:",
  "Selecione o motivo da pausa": "Selecione o motivo da pausa",
  "Marcar Ponto": "Marcar Ponto",
  "Marcar Pausa": "Marcar Pausa",
  "Em Pausa": "Em Pausa",
  "Voltar da pausa": "Voltar da pausa",
  "Cancelar": "Cancelar",
  "Confirmar pausa": "Confirmar pausa",
  "Marcar pausa": "Marcar pausa",
  "Início": "Início",
  "Lembretes": "Lembretes",
  "Gestão de tarefas": "Gestão de tarefas",
  "Comunicados": "Comunicados",
  "Documentos": "Documentos",
  "Feedbacks": "Feedbacks",
  "Reuniões 1:1": "Reuniões 1:1",
  "Reembolsos": "Reembolsos",
  "Saldo de horas": "Saldo de horas",
  "Solicitações de ajuste": "Solicitações de ajuste",
  "Férias/Afastamento": "Férias e Afastamentos",
  "Histórico de Ponto": "Histórico de Ponto",
  "Espelhos de Ponto": "Espelhos de Ponto",
  "Log de Registros": "Log de Registros",
  "Modo ponto": "Modo ponto",
  "Minha equipe": "Minha equipe",
  "Gestão de Ponto": "Gestão de Ponto",
  "Gerenciar afastamentos": "Gerenciar afastamentos",
  "Solicitações da equipe": "Solicitações da equipe",
  "Sobreaviso": "Sobreaviso",
  "Modo escuro": "Modo escuro",
  "Modo claro": "Modo claro",
  "Meu perfil": "Meu perfil",
  "Ouvidoria": "Ouvidoria",
  "Política de privacidade": "Política de privacidade",
  "Sair": "Sair"
};



// WEBPACK FOOTER //
// ./src/resources/ptBR/leftMenu.js